export default __webpack_public_path__ + "static/media/pitchnet2.d8fb47b3.mp4";